import { memo } from "react";

interface SubscriptionSummaryItemProps {
  id: string;
  name: string;
  price: string;
  plan: string;
  platforms: string[];
  isExpanded: boolean;
  onToggle: () => void;
}

function SubscriptionSummaryItem({
  name,
  price,
  plan,
  platforms,
  isExpanded,
  onToggle,
}: SubscriptionSummaryItemProps) {
  return (
    <div className="">
      <button
        onClick={onToggle}
        className="flex w-full items-center justify-between transition-colors"
      >
        <div className="flex h-10 w-full items-center gap-4">
          <i
            className={`ri-arrow-down-s-fill text-white transition-transform ${
              isExpanded ? "rotate-180" : ""
            }`}
          ></i>
          <div className="flex w-full items-center justify-between gap-8 text-sm leading-normal tracking-normal">
            <span className="font-bold text-white">{name}</span>
            <span className="font-medium">{price}</span>
          </div>
        </div>
      </button>

      {isExpanded && (
        <div className="space-y-3 p-4 pl-8 text-sm">
          <div className="flex gap-4">
            <span className="min-w-[80px] font-bold text-white">Plan</span>
            <p className="font-medium text-gray-400">{plan}</p>
          </div>
          {plan !== "Usage" && (
            <div className="flex gap-4">
              <span className="min-w-[80px] font-bold text-white">
                Platform
              </span>
              <p className="font-medium text-gray-400 capitalize">
                {platforms.join(", ")}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default memo(SubscriptionSummaryItem);
